import { CLOSE_REASONS_TYPES } from 'modules/queues/constants/appointmentsFilters';

export const getAppointmentsFilters = state => {
  const {
    closeReasons,
    dateRange,
    lastConversationStatuses,
    assignees,
    scheduleTypes,
    isGroupAppointment,
    services,
    consultationTypes,
    conversationTypes,
  } = state.queues.archive.archiveAppointmentsFilters;

  const filters = {};

  filters.appointmentStatus = closeReasons.length
      ? closeReasons
      : Object.keys(CLOSE_REASONS_TYPES);

  if (dateRange.startDate) {
    filters.date = {
      ...filters.date,
      from: dateRange.startDate.getTime(),
      type: dateRange.type,
    };
  }

  if (dateRange.endDate) {
    filters.date = {
      ...filters.date,
      to: dateRange.endDate.getTime(),
      type: dateRange.type,
    };
  }

  if (assignees.length) filters.assignment = assignees;
  if (lastConversationStatuses.length) filters.lastConversationStatuses = lastConversationStatuses;
  if (services.length) filters.serviceIds = services;
  if (scheduleTypes.length) filters.appointmentServiceQueueType = scheduleTypes;
  if (isGroupAppointment.length === 1) {
    filters.isGroupAppointment = isGroupAppointment.includes('YES');
  }
  if (consultationTypes.length) filters.consultationTypes = consultationTypes;
  if (conversationTypes.length) filters.conversationTypes = conversationTypes;

  return filters;
};
